import { render, staticRenderFns } from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=template&id=4c90e7b1&lang=pug&"
import script from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=script&lang=js&"
export * from "./TableRowNumAudiogramsByAudiologist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c90e7b1')) {
      api.createRecord('4c90e7b1', component.options)
    } else {
      api.reload('4c90e7b1', component.options)
    }
    module.hot.accept("./TableRowNumAudiogramsByAudiologist.vue?vue&type=template&id=4c90e7b1&lang=pug&", function () {
      api.rerender('4c90e7b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/monthly/TableRowNumAudiogramsByAudiologist.vue"
export default component.exports